import { z } from "zod";

export const createDateRangeSchema = (required: boolean) => {
  return z
    .object({
      type: z.enum(["input", "variable"]),
      start: z.string().optional(),
      end: z.string().optional(),
      value: z.string().optional(),
      node_id: z.string().optional(),
      value_type: z.enum(["field", "object", ""]).optional(),
    })
    .superRefine((data, ctx) => {
      const hasStart = data.start && data.start.trim().length > 0;
      const hasEnd = data.end && data.end.trim().length > 0;
      const hasValue = data.value && data.value.trim().length > 0;

      if (data.type === "input") {
        // If required, both start and end must be present
        if (required) {
          if (!hasStart) {
            ctx.addIssue({
              code: "custom",
              message: "La fecha de inicio es obligatoria",
              path: ["start"],
            });
          }
          if (!hasEnd) {
            ctx.addIssue({
              code: "custom",
              message: "La fecha de fin es obligatoria",
              path: ["end"],
            });
          }
        } else {
          // If not required but one is present, the other must be present too
          if (hasStart && !hasEnd) {
            ctx.addIssue({
              code: "custom",
              message:
                "La fecha de fin es obligatoria cuando se proporciona fecha de inicio",
              path: ["end"],
            });
          }
          if (hasEnd && !hasStart) {
            ctx.addIssue({
              code: "custom",
              message:
                "La fecha de inicio es obligatoria cuando se proporciona fecha de fin",
              path: ["start"],
            });
          }
        }
      }

      if (data.type === "variable") {
        // Value is required if the field is required
        if (required && !hasValue) {
          ctx.addIssue({
            code: "custom",
            message: "El valor es obligatorio",
            path: ["value"],
          });
        }

        // If value is present, node_id and value_type must be present
        if (hasValue) {
          if (!data.node_id || data.node_id.trim().length === 0) {
            ctx.addIssue({
              code: "custom",
              message: "El nodo es obligatorio",
              path: ["node_id"],
            });
          }
          if (!data.value_type) {
            ctx.addIssue({
              code: "custom",
              message: "El tipo de valor es obligatorio",
              path: ["value_type"],
            });
          }
        }
      }
    });
};

export const getDateRangeDefaultValues = () => {
  return {
    type: "input",
    start: "",
    end: "",
    value: "",
    node_id: "",
    value_type: "",
  };
};
